<template>
  <BaseViewComponent
    name="features-list"
    :is-preview="isPreview"
  >
    <div class="features-list-wrapper full-width flex justify-between items-center">
      <div class="container">
        <div class="text flex column items-center q-pt-sm">
          <div class="title-wrapper">
            <div
              v-if="pageData.featuresListSubtitle"
              class="title-h4 border-radius-10 q-py-sm q-px-md"
            >
              {{ pageData.featuresListSubtitle }}
            </div>
          </div>
          <div class="title-h2 q-mt-sm">{{ pageData.featuresListTitle }}</div>
          <div class="text-p">{{ pageData.featuresListDescription }}</div>
        </div>
        <div class="flex column items">
          <div
            v-for="(item, index) in pageData.featuresListItems"
            :key="index"
            class="flex item items-start"
          >
            <div class="image relative-position">
              <div class="number absolute flex items-center justify-center">{{ index + 1 }}</div>
              <img
                :src="getImage(item)"
                class="border-radius-20"
                width="100%"
              >
            </div>
            <div class="flex flex-1 column item-text">
              <div class="title-h3">{{ item.title }}</div>
              <div class="title-h4">{{ item.subtitle }}</div>
              <div class="text-p">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import getCompressImage from 'src/helpers/getCompressImage';

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);

function getImage(item) {
  const img = item.imagePreview || item.image;
  return img ? getCompressImage(img) : '/landing/features-list-cover.png';
}
</script>
